import React, { useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { 
  FBOSearchPost, 
  contractOpportunititesPost, 
  futureOpportunitiesSearchPost, 
  businessSearchPost, 
  purchaseSearchPost, 
  contractingOfficerSearchPost,
  usersSearchPost
} from '../../api';
import { UserContext } from '../../context/User';
import { useHistory, Link } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import { somethingWentWrongNotice } from '../UI/Notifications';
import { SearchContext } from '../../context/Search';
import TableContainer from "./TableContainer";
import Pagination from "../Pagination";
import PageSwitcher from "../PageSwitcher";
import Loading from '../Loading';
import classes from './index.module.scss';

const REQUESTS = {
  contract_opportunities_reports: FBOSearchPost,
  b2b_opportunities_reports: purchaseSearchPost,
  future_opportunities: futureOpportunitiesSearchPost,
  businesses_reports: businessSearchPost,
  purchases_reports: contractOpportunititesPost,
  contract_officers: contractingOfficerSearchPost,
  users: usersSearchPost
}

const ReportResult = () => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [offset, setOffset] = useState(0);
  const [active, setActive] = useState("");
  const [limit, setLimit] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [searchedData, setSearchedData] = useState([]);
  const [forcePage, setForcePage] = useState(0);
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();
  const [sorted, setSorted] = useState(false);
  const [orderByParams, setOrderByParams] = useState([]);
  const qs = require('qs');
  const [headerParams, setHeaderParams] = useState([]);
  const [requestData, setRequestData] = useState({});

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Search");
    }

    setLoading(false);
  }
  
  const dataStructuring = (fullTextParams, queryParams, entity) => {
    setLoading(true);
    delete queryParams.entity;
    delete queryParams.select;
    setRequestData(queryParams);
    requestHandler(fullTextParams, qs.parse(queryParams), entity);
  }

  const searchHandler = (queryParams, entity, select) => {
    const selectWithId = [...select, "id"];

    const fullTextParams = {
      limit: limit,
      offset: offset,
      select: selectWithId
    };

    dataStructuring(fullTextParams, queryParams, entity);
  }
  
  useEffect(() => {
    let queryParams = {};

    query.forEach((value, key) => {
      queryParams[key] = query.getAll(key).length !== 1 ? 
      query.getAll(key): 
      query.get(key);
    });

    for (let prop in queryParams) {
      if (queryParams[prop] === 'false') {
        queryParams[prop] = false
      } else if (queryParams[prop] === 'true') {
        queryParams[prop] = true
      }
    }
    
    const entity = queryParams.entity;
    const parsedParams = qs.parse(queryParams);
    
    setHeaderParams(parsedParams.select);
    setActive(entity);
    searchHandler(parsedParams, entity, parsedParams.select);
  }, [limit, offset, orderByParams])
  
  const requestHandler = (fullTextParams, data, entity) => {
    REQUESTS[entity](fullTextParams, data)
    .then(response => {
      setSearchedData(response.data.results);
      setTotalCount(response.data.total_count);
      setLoading(false);
    })
    .catch(error => {
      error.response.status === 404 ? 
      setSearchedData([]) : 
      handleDefaultStatusCodes(error.response.status); 
      setLoading(false);
    })
  }

  const downloadCSVFileHandler = () => {
    setLoading(true);
    REQUESTS[active]({
      select: headerParams,
      offset: 0,
      limit: 0
    }, requestData, {Accept: 'text/csv'})
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'report.csv'); //or any other extension
      document.body.appendChild(link);
      link.click();
      setLoading(false);
    })
    .catch(error => {
      console.log(error)
      handleDefaultStatusCodes(error.response.status); 
      setLoading(false);
    })
  }

  return (
    <Container>
      <Row>
        <Col>
          <div className={classes.Header_Wrap}>
            <h3 className="my-5">Administrative Report Results</h3>
            <div className={classes.Btn_Wrap}>
              <Link
                className="btnSizes transparentBtn"
                to="/reports"
              >
                New Report
              </Link>
              <button
                className="btnSizes filledBtn ml-4"
                onClick={downloadCSVFileHandler}
              >
                Download Report
              </button>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          {!searchedData.length && (
            <h3 className="my-5">No results</h3>
          )}
          <SearchContext.Provider value={{
            setOrderByParams,
            orderByParams,
            setSorted,
            sorted,
            setSearchedData,
            searchedData,
            totalCount,
            limit,
            offset,
            setLimit,
            setOffset,
            forcePage,
            setForcePage,
            pageCount,
            setPageCount,
            loading,
            active,
            headerParams
          }}>
            {!!searchedData && !!searchedData.length && (
              <>
                <TableContainer />
              </>
            )}
            {searchedData && !!searchedData.length && !!totalCount && (
              <div className="pagination-wrap">
                <Pagination />
                <PageSwitcher />
              </div>
            )}
          </SearchContext.Provider>
          {loading && <Loading />}
        </Col>
      </Row>
    </Container>
  );
};

export default ReportResult;